import React, { useEffect, useState } from "react";
import "./styles/InfoPortafolio.css";
import TablePortafolioTech from "./TablePortafolioTech";
import Search from "../generales/Search";
import LoadSimple from "../LoadSimple";
import TablePortafolioDevices from "./TablePortafolioDevices";
import Action from "../Action";
import Modal from "react-modal";
import ModalCreateTech from "./ModalCreateTech"
/* estilos modal crear configuracion */
const CreateCisModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "60%",
    padding: "20px",
  },
};
const InfoPortafolio = ({
  server,
  portfolioSelected,
  onSearch,
  dataUsers,
  setDataUsers,
  setServiceSelected,
  ServiceSelected,
  sla,
  setSla,
  languaje,
  dataObject,
  setDataObject
}) => {
  const limitList = 20;

  const [pageActual, setPageActual] = useState(1);
  const [viewDevicesTecnologies,setViewDevicesTecnologies]=useState(true)
  const [dataCisConf, setDataCisConf] = useState({
    data: [],
    loading: true,
    error: null,
  });
  // console.log(ServiceSelected)
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  var dataList = searchTerm === "" ? dataCisConf.data : searchResults;
  const startLimit = limitList * pageActual - limitList;
  const pages = parseInt(dataList.length / limitList) + 1;
  const [tecSelected,setTecSelected]=useState({})
  const [registerIsValid, setRegisterIsValid] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dataCis, setDataCis] = useState([]);
  const [loadingCis, setLoadingCis] = useState(false);
  const [errorCis, setErrorCis] = useState(null);
  const [TechSelected, setTechSelected] = useState([]);
  const [editActive, setEditActive] = useState(false);
  const [dataTech, setDataTech] = useState([]);
  const [CreateTechModalOpen, setCreateTechModalOpen] = useState(false);
  const [slaTech,setSlaTech]=useState(0)
  const crear = () => {
    setCreateTechModalOpen(true);
  };
  function closCreateTechModal() {
    setEditActive(false);
    setCreateTechModalOpen(false);
    search_tecnologies()
  }
  const handleChangEdit = (element) => {
    // console.log("handle edit");
    setEditActive(true);
    // console.log(element);
    setDataTech(element);
          setCreateTechModalOpen(true);
  };

  useEffect(() => {
    search_tecnologies();
  }, []);

  const search_tecnologies = () => {
    // setLoadingCis(true)
    setDataCisConf({
      data: dataCisConf.data,
      loading: true,
      error: dataCisConf.error,
    });
    const fetchDataPost = async () => {
      try {
        
        const response = await fetch(
          server.url +
            "/api/v1/cassia/services/techs/" +
            ServiceSelected.cassia_tech_service_id,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        // console.log(response);
        if (response.ok) {
          const data1 = await response.json();
          setDataObject(data1)
          setDataCisConf({
            data: data1,
            loading: false,
            error: dataCisConf.error,
          });

          setSla(data1.data.sla_service)
          // setDataTech(data1)
          setPageActual(1);

          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          // console.log(data1);
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  const regresar_tec = () => {
    search_tecnologies()
    setTecSelected([])
    setViewDevicesTecnologies(true)
    // setLoadingCis(true)
  };
  // console.log(tecSelected)
  return (
    <>
      
      <div className="cont_info_cis">
        <div className="body_info_cis">
          <div
            className="content-portafolio"
            style={{ border: "px solid #607582", boxShadow: "unset" }}>
            {
              (viewDevicesTecnologies)?
              <div className="cont-portafolio-search" style={{ background: "#0166a0" }}>
              <>
                {/* <div className="cont-search-lefth hiddenPDF"> */}
                  {dataCisConf.loading ? (
                    ""
                  ) : (
                    <>
                      <div className="cont-search" style={{ width: "30%" }}>
                        <Search
                          searchResults={searchResults}
                          setSearchResults={setSearchResults}
                          searchTerm={searchTerm}
                          setSearchTerm={setSearchTerm}
                          onSearch={onSearch}
                          dataObject={dataCisConf.data.data.techs}
                          setDataObject={setDataCisConf}
                          languaje={languaje}
                        />
                        <p style={{ color: "aliceblue", textAlign: "center" }}>
                          &nbsp;
                          {searchTerm !== ""
                            ? searchResults.length+ " resultados"
                            : dataCisConf.data.data.techs.length + " resultados"}
                        </p>
                      </div>
                    </>
                  )}
                {/* </div> */}
                <div className="cont-search-space"></div>
                <div className="cont-search-buttons">
                  
                    <Action
                    disabled={false}
                    origen="Blanco"
                    titulo="+ Crear Tecnología"
                    action={crear}
                  />
                  
                 
                </div>
              </>
            </div>:
             <div className="cont-portafolio-search" style={{ background: "rgb(75, 92, 121)" }}>
              <>
                <div
                  className="cont-btn-back-users"
                  style={{ width: "10%" }}
                  onClick={regresar_tec}
                >
                  <div className="cont-img-back-users">
                    <img
                      className="img-back-users"
                      src={"/iconos/back-blanco.png"}
                      name="regresar"
                    />
                  </div>
                  <div className="cont-txt-back-users">
                    <div className="txt-back-users">Regresar</div>
                  </div>
                </div>
                <div className="txt-back-users">{tecSelected.tech_name}&nbsp;&nbsp;&nbsp;&nbsp;{'SLA: '+slaTech+"%"}</div>
              </>
             </div>
            }

            <div className="cont-portafolio-table">
              <div className="content-card-portafolio">
               {(viewDevicesTecnologies)? <>
                {dataCisConf.loading ? (
                  <LoadSimple></LoadSimple>
                
                ) : (
                  <TablePortafolioTech
                  server={server}
                  editActive={editActive}
                  setEditActive={setEditActive}
                  dataTech={dataTech}
      setDataTech={setDataTech}
                  setData={setData}
                  loading={loading}
                  setLoading={setLoading}
                  setError={setError}
                  setRegisterIsValid={setRegisterIsValid}
                  closCreateManttoModal={closCreateTechModal}
                  tecSelected={tecSelected}
                  setTecSelected={setTecSelected}
                  search_tecnologies={search_tecnologies}
                    searchResults={searchResults}
                    handleChangEdit={handleChangEdit}
                    dataCisConf={dataCisConf}
                    searchTerm={searchTerm}
                    viewDevicesTecnologies={viewDevicesTecnologies}
                    setViewDevicesTecnologies={setViewDevicesTecnologies}
                    slaTech={slaTech}
                    setSlaTech={setSlaTech}
                    languaje={languaje}
                  ></TablePortafolioTech>
                  
                )}
                </>:
                <TablePortafolioDevices
                tecSelected={tecSelected}
                  setTecSelected={setTecSelected}
                search_tecnologies={search_tecnologies}
                searchResults={searchResults}
                server={server}
                dataCisConf={dataCisConf}
                searchTerm={searchTerm}
                viewDevicesTecnologies={viewDevicesTecnologies}
                setViewDevicesTecnologies={setViewDevicesTecnologies}
                slaTech={slaTech}
                setSlaTech={setSlaTech}
                sla={sla}
                setSla={setSla}
                languaje={languaje}
                ></TablePortafolioDevices>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
    isOpen={CreateTechModalOpen}
    // isOpen={false}
    // onAfterOpen={afterOpenExeption}
    onRequestClose={closCreateTechModal}
    style={CreateCisModalStyles}
    contentLabel="Example Modal2"
    // shouldCloseOnOverlayClick={false}
    >
        <ModalCreateTech
      // devices={devices}
      TechSelected={TechSelected}
      ServiceSelected={ServiceSelected}
      server={server}
      dataCisConf={dataCisConf}
      editActive={editActive}
      setEditActive={setEditActive}
      dataTech={dataTech}
      setDataTech={setDataTech}
      setData={setData}
      loading={loading}
      setLoading={setLoading}
      setError={setError}
      setRegisterIsValid={setRegisterIsValid}
      closCreateTechModal={closCreateTechModal}
    ></ModalCreateTech>
    </Modal>
    </>
  );
};

export default InfoPortafolio;
